import * as errorPageTypes from '../../consts/app/errorPageTypes';
import * as routePaths from '../../consts/route/routePaths';
import * as routeValues from '../../consts/route/routeValues';
import {setErrorPageType} from '../../state/ducks/global';
import {dispatch} from '../../state/store';
import helpers from '../../utils/helpers';
import urlUtils from '../../utils/urlUtils';
import connectivityService from '../device/connectivityService';
import routerService from '../routerService';
import httpStatusTypesService from '../server/httpStatusTypesService';

const forwardToAgeGatePage = () => routerService.forwardTo(routePaths.AGE_GATE);
const forwardToBrowserVerificationPage = () => routerService.forwardTo(routePaths.BROWSER_VERIFICATION);
const forwardToConnectionFlowPage = (deviceType, isRetry) => {
    if (connectivityService.isUsb()) {
        routerService.forwardTo(
            urlUtils.join(routePaths.PAIRING_GUIDE_HID, isRetry ? routeValues.USB_CONNECTION_RETRY : '')
        );
    } else {
        if (isRetry) {
            forwardToPairingGuidePage({deviceType, isPairingRetry: isRetry});
        } else {
            forwardToSelectDevice();
        }
    }
};
const forwardToErrorHandlingPage = (errorType) => {
    dispatch(setErrorPageType(errorType));
    routerService.forwardTo(routePaths.ERROR_PAGE);
};
const forwardToIccErrorHandlingPage = (status) => {
    //check error status for icc maintenance
    const errorType = httpStatusTypesService.isServiceUnavailable(status)
        ? errorPageTypes.ICC_UNAVAILABLE_ERROR
        : errorPageTypes.ICC_TEMPORARY_ERROR;

    forwardToErrorHandlingPage(errorType);
};
const forwardToNotCompatibleBrowserPage = () => routerService.forwardTo(routePaths.NOT_COMPATIBLE_BROWSER);
const forwardToPairingAlertPage = () => routerService.forwardTo(routePaths.PAIRING_ALERT);
const forwardToPairingGuidePage = ({deviceType, isPairingRetry}) => {
    const pairingGuid = isPairingRetry ? helpers.guid() : '';

    routerService.forwardTo(urlUtils.join(routePaths.PAIRING_GUIDE, deviceType, pairingGuid));
};
const forwardToPairingSuccessPage = () => routerService.forwardTo(routePaths.PAIRING_SUCCESS);
const forwardToCheckingFwu = () => routerService.forwardTo(routePaths.CHECKING_UPDATE);
const forwardToRoot = () => routerService.forwardTo(routePaths.ROOT);
const forwardToSelectDevice = () => routerService.replace(routePaths.SELECT_DEVICE);
const forwardToTNCDataCollectionPage = () => routerService.forwardTo(routePaths.TNC_DATA_COLLECTION);
const forwardToTNCPreferenceCenterPage = () => routerService.forwardTo(routePaths.TNC_DATA_PREFERENCE);
const forwardToTNCTermsOfUsePage = () => routerService.forwardTo(routePaths.TNC_TERMS_OF_USE);
const forwardToLegalDisclaimerPage = () => routerService.forwardTo(routePaths.LEGAL_DISCLAIMER);
const forwardToAppLockedPage = () => routerService.forwardTo(routePaths.APP_LOCKED);
const forwardToNotAvailablePage = () => routerService.forwardTo(routePaths.NOT_AVAILABLE);
const forwardToImportantPage = () => routerService.forwardTo(routePaths.IMPORTANT);
const forwardToConnectingPage = () => routerService.forwardTo(routePaths.CONNECTING);
const forwardToCannotDetectLocationPage = () => routerService.forwardTo(routePaths.CANNOT_DETECT_LOCATION);
const forwardToSummaryUpdatePage = () => routerService.forwardTo(routePaths.SUMMARY_UPDATE);
const forwardToContactUsPage = () => routerService.forwardTo(routePaths.CONTACT_US);
const forwardToUpdateFWPage = ({target, version = helpers.guid(), isSblFirmware = false}) =>
    routerService.forwardTo(
        urlUtils.join(routePaths.UPDATE, '?' + urlUtils.stringify({target, version, isSblFirmware}))
    );
const forwardToUpToDatePage = (successFwuCount = 1) =>
    routerService.forwardTo(urlUtils.join(routePaths.UP_TO_DATE, successFwuCount.toString()));
const forwardToUpToDateFailedPage = () => routerService.forwardTo(routePaths.UP_TO_DATE_FAILED);
const isTncRoute = (pathname) =>
    pathname === routePaths.TNC_TERMS_OF_USE ||
    pathname === routePaths.TNC_DATA_COLLECTION ||
    pathname === routePaths.TNC_DATA_PREFERENCE;

if (process.env.REACT_APP_ENV !== 'prod') {
    window.forwardTo = routerService.forwardTo;
}

export default {
    forwardToAgeGatePage,
    forwardToAppLockedPage,
    forwardToBrowserVerificationPage,
    forwardToCannotDetectLocationPage,
    forwardToConnectingPage,
    forwardToConnectionFlowPage,
    forwardToErrorHandlingPage,
    forwardToIccErrorHandlingPage,
    forwardToImportantPage,
    forwardToLegalDisclaimerPage,
    forwardToNotAvailablePage,
    forwardToNotCompatibleBrowserPage,
    forwardToPairingAlertPage,
    forwardToPairingGuidePage,
    forwardToPairingSuccessPage,
    forwardToRoot,
    forwardToSelectDevice,
    forwardToTNCDataCollectionPage,
    forwardToTNCPreferenceCenterPage,
    forwardToTNCTermsOfUsePage,
    forwardToCheckingFwu,
    forwardToSummaryUpdatePage,
    forwardToContactUsPage,
    forwardToUpdateFWPage,
    forwardToUpToDatePage,
    forwardToUpToDateFailedPage,
    isTncRoute,
};
